<template>
  <a-card :bordered="false" :headStyle="{fontSize:'18px',width: '100%'}" :body-style="{width: '100%'}">
    <search-page-view
      :col="3"
      ref="table"
      :itemNames="['s1','s2','s9','s3','s4','s5','s6','s7','s8']"
      rowKey="orderNo"
      :enableSearch="false"
      :queryParams="queryParams"
      :columns="getColumns()"
      :requestPromise="getListPromise"
    >
      <a-form-item slot="s1" label="预约订单号" v-bind="searchItemLayout">
        <a-input v-model="queryParams.orderNo" placeholder="请输入"></a-input>
      </a-form-item>
      <a-form-item slot="s2" label="抢购订单号" v-bind="searchItemLayout">
        <a-input v-model="queryParams.preOrderNo" placeholder="请输入"></a-input>
      </a-form-item>
      <a-form-item slot="s9" label="订单状态" v-bind="searchItemLayout">
        <a-select
          style="width: 100%"
          v-model="queryParams.orderStatus"
          placeholder="请选择"
          :allowClear="true"
        >
          <a-select-option v-for="(item,index) in orderStatusList" :key="index" :value="item.value">
            {{ item.text }}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item slot="s3" label="预约码" v-bind="searchItemLayout">
        <a-input v-model="queryParams.redeemCode" placeholder="请输入"></a-input>
      </a-form-item>
      <a-form-item slot="s4" label="商品名称" v-bind="searchItemLayout">
        <a-input v-model="queryParams.proName" placeholder="请输入"></a-input>
      </a-form-item>
      <a-form-item slot="s4" label="联系人姓名" v-bind="searchItemLayout">
        <a-input v-model="queryParams.contactName" placeholder="请输入"></a-input>
      </a-form-item>
      <a-form-item slot="s6" label="联系人手机号" v-bind="searchItemLayout">
        <a-input v-model="queryParams.contactPhone" placeholder="请输入"></a-input>
      </a-form-item>
      <a-form-item slot="s7" label="出游日期" v-bind="searchItemLayout">
        <a-range-picker
          :disabledDate="disabledDate"
          @change="onDateChange"
          format="YYYY-MM-DD"
          @calendarChange="handlePanelChange"
          @openChange="openChange"
          :mode="mode"
          style="width: 100%"/>
      </a-form-item>
      <a-form-item slot="s8" style="padding-left:2%;box-sizing: border-box">
        <a-button type="primary" @click="onSearch">查询</a-button>
        <a-button style="margin: 0 10px" @click="onExport">导出</a-button>
        <a-button @click="toStatement">查看已生成报表</a-button>
      </a-form-item>

      <template slot="customUser" slot-scope="rowItem">
        {{ rowItem.record.orderContact }}<br/>{{ rowItem.record.orderMobile }}
      </template>
      -->
      <template slot="number" slot-scope="rowItem">
        {{ rowItem.record.usedNum }}/{{ rowItem.record.stockNum }}
      </template>
      <template slot="orderStatus" slot-scope="rowItem">
        {{ rowItem.text|preOrderStateName }}
      </template>
      <template slot="redeemCode" slot-scope="rowItem">
        {{ rowItem.record.redeemCodeList.join(',') }}
      </template>
      <template slot="preSaleOrderNoList" slot-scope="rowItem">
        {{ rowItem.record.preSaleOrderNoList.join(',') }}
      </template>
      <template slot="travelDate" slot-scope="rowItem">
        {{ rowItem.record.travelDate ? rowItem.record.travelDate : (rowItem.record.checkInDate + ' ~ ' + rowItem.record.departureDate) }}
      </template>

      <template slot="action" slot-scope="rowItem" l>
        <a @click="toOrderDetail(rowItem.record)">查看订单</a>
      </template>
    </search-page-view>
  </a-card>

</template>

<script>
import searchForm from '@/utils/mixins/searchFormMixins'


export default {
  name: 'CouponOrderList',
  mixins: [searchForm],
  data() {
    return {
      queryParams: {},
      mode: ['date', 'date'],
      value: [],
      startValue: '',
      orderStatusList: [
        {
          text: '已确认',
          value: 0
        },
        {
          text: '未确认',
          value: 1
        },
        {
          text: '商家已拒绝',
          value: 2
        },
        {
          text: '已关闭',
          value: 3
        },
        {
          text: '已退款',
          value: 8
        }
      ]
    }
  },
  mounted() {
    this.queryParams.merchantId = this.$store.getters.userInfo.merchantId
  },
  methods: {
    handlePanelChange(value) {
      this.startValue = value[0]._d
    },
    //禁选开始时间前后365天
    disabledDate(current) {
      return current._d.getTime() > new Date(this.startValue).getTime() + 8.64e7 * 365 || current._d.getTime() < new Date(this.startValue).getTime() - 8.64e7 * 365
    },
    //日期选择框关闭回调
    openChange(open) {
      if (!open) {
        this.startValue = ''
      }
    },
    onSearch() {
      this.$refs.table.refresh(true)
    },
    toStatement() {
      this.$router.push({
        name: 'DownloadTable'
      })
    },
    onExport() {
      if (!this.queryParams.travelDateStart && !this.queryParams.travelDateEnd) {
        this.$message.error('请选择出游日期')
        return
      }
      this.getHttpServices().getOrderService().post('order/bespeak/exportOrderList', this.queryParams)
        .then(res => {
          this.$message.success('成功导出')
        })
        .catch(reason => {
          this.$message.error('导出失败')
          console.error(reason)
        })
    },
    onDateChange(dates, dateStrArr) {
      this.value = dateStrArr
      this.queryParams.travelDateStart = dateStrArr[0]
      this.queryParams.travelDateEnd = dateStrArr[1]
    },
    // 获取表格数据接口
    getListPromise(params) {
      this.getLogUtils().logWithTag('==getOrderListPromise==', params)
      return this.getHttpServices().getOrderService().post('order/bespeak/selectReserveOrderPage', params)
    },
    getColumns() {
      return [
        {
          title: '预约订单号',
          dataIndex: 'orderNo',
          width: '110px'
        },
        {
          title: '抢购订单号',
          dataIndex: 'preSaleOrderNoList',
          width: '110px',
          scopedSlots: { customRender: 'preSaleOrderNoList' }
        },
        {
          title: '商品信息',
          dataIndex: 'proName',
          width: '25%'
        },
        {
          title: '预约量',
          dataIndex: 'num'
        },
        {
          title: '预约码',
          dataIndex: 'redeemCode',
          width: '80px',
          scopedSlots: { customRender: 'redeemCode' }
        },

        {
          title: '联系人',
          dataIndex: 'customUser',
          scopedSlots: { customRender: 'customUser' }
        },
        {
          title: '出游日期',
          dataIndex: 'travelDate',
          scopedSlots: { customRender: 'travelDate' }
        },
        {
          title: '差价金额',
          dataIndex: 'orderPaidFee'
        },
        {
          title: '订单状态',
          dataIndex: 'orderStatus',
          scopedSlots: { customRender: 'orderStatus' }
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '90px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ]
    },
    toOrderDetail(record) {
      this.openNewPage('CouponOrderDetail', { orderNo: record.orderNo })
    }
  }

}
</script>
<style scoped>
</style>